export default __webpack_public_path__ + "static/media/headset.8533b284.svg";